// no host has accepted the invitation to host the event
export const isEventPendingHost = (
	event: TGetAllEventCommon | TSingleLiveEventData
) => {
	return !event?.isHostApplicationAccepted;
};
